import React from "react";
import { Modal } from "react-bootstrap";
import { OMSButtonStyleL2 } from "../../../../app/common/common-components/OMSButton";

interface ConfirmReportPurchaseModalPopupProps {
  showModal: boolean;
  title: string;
  creditBalance: number;
  reportCost: number;
  closeModalPopup: () => void;
  confirmModalPopup: () => void;
  openPurchaseCreditsModal: () => void; // Function to open the purchase credits modal
  isProcessing?: boolean; // New prop to indicate processing state
}

const ConfirmReportPurchaseModalPopup: React.FC<ConfirmReportPurchaseModalPopupProps> = ({
  showModal,
  title,
  creditBalance,
  reportCost,
  closeModalPopup,
  confirmModalPopup,
  openPurchaseCreditsModal,
  isProcessing = false, // Default to false
}) => {
  const remainingCredits = creditBalance - reportCost;

  // Handle modal close based on processing state
  const handleModalClose = () => {
    if (!isProcessing) {
      closeModalPopup();
    }
  };

  return (
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Current Credit Balance: {creditBalance} Credits</p>
        <p>This report will cost: {reportCost} Credits</p>
        <p>Credits remaining after deduction: {remainingCredits >= 0 ? remainingCredits : 0}</p>
        {remainingCredits < 0 && (
          <p style={{ color: "red" }}>
            Not enough credits?{" "}
            <a href="#" onClick={openPurchaseCreditsModal}>
              Purchase Credits
            </a>
          </p>
        )}
        {isProcessing && (
          <p style={{ color: "blue" }}>
            Retrieving report details, please wait...
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button 
          className="btn btn-default" 
          onClick={closeModalPopup}
          disabled={isProcessing}
        >
          Cancel
        </button>
        <OMSButtonStyleL2
          type="button"
          style={{ marginRight: 10 }}
          ui_icon=""
          ui_type="save"
          ui_text="Confirm"
          ui_processing_text="Processing..."
          disabled={remainingCredits < 0 || isProcessing}
          onClick={() => {
            if (remainingCredits >= 0 && !isProcessing) {
              confirmModalPopup();
            }
          }}
          processing={isProcessing}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmReportPurchaseModalPopup;
